import React from 'react';

import { NarrowSelect } from '../styled';
import { Field } from 'shared/containers/form';

export default function RoleSelect({ disabled }) {
  return (
    <Field
      placeholder="Role"
      name="custom:type"
      component={NarrowSelect}
      disabled={disabled}
      {...{ options }}
    />
  );
}

const options = [
  { label: '--select--', value: '' },
  { label: 'Admin', value: 'admin' },
  { label: 'Power User', value: 'power user' },
  { label: 'Basic', value: 'basic' },
  { label: 'Guest', value: 'guest' },
];
